import React from 'react';
import { Users, TrendingUp, AlertTriangle, Award } from 'lucide-react';

const StatsOverviewWidget = ({ stats, role }) => {
  const getStatsForRole = () => {
    switch(role) {
      case 'hod':
      case 'mentoringCoordinator':
        return [
          { label: 'Total Students', value: stats.totalStudents, icon: Users, color: 'blue' },
          { label: 'Avg Attendance', value: `${stats.avgAttendance}%`, icon: TrendingUp, color: 'green' },
          { label: 'At Risk', value: stats.atRisk, icon: AlertTriangle, color: 'red' },
          { label: 'Achievements', value: stats.totalAchievements, icon: Award, color: 'purple' }
        ];
      case 'classCoordinator':
        return [
          { label: 'Division Students', value: stats.totalStudents, icon: Users, color: 'blue' },
          { label: 'Avg Attendance', value: `${stats.avgAttendance}%`, icon: TrendingUp, color: 'green' },
          { label: 'At Risk', value: stats.atRisk, icon: AlertTriangle, color: 'red' }
        ];
      default:
        return [];
    }
  };

  const statsData = getStatsForRole();

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {statsData.map((stat, index) => (
        <div key={index} className={`bg-${stat.color}-50 rounded-lg p-4`}>
          <div className="flex items-center justify-between mb-2">
            <stat.icon className={`w-6 h-6 text-${stat.color}-600`} />
          </div>
          <div className={`text-2xl font-bold text-${stat.color}-900`}>{stat.value}</div>
          <div className="text-sm text-gray-600">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverviewWidget;